import React, { useState, useEffect } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import styled from 'styled-components';

const Content = styled.div.attrs({
  className:
    'bg-white p-4 sm:p-3 text-gray-100 text-2xl cursor-pointer flex items-center justify-between rounded-lg',
})``;
const DropButton = styled.div.attrs({
  className: 'flex items-center justify-center ml-4',
})`
  width: 20px;
`;
const Option = styled.div.attrs({
  className: 'text-gray-100 p-2 hover:text-primary',
})`
  font-size: 14px;
  line-height: 18px;

  &:hover {
    background: rgba(24, 28, 52, 0.05);
  }
`;
const Dropdown = styled.div.attrs({
  className:
    'overflow-auto w-full py-3 mt-2 bg-white border border-lightest-gray rounded-large cursor-pointer absolute',
})`
  max-height: 500px;

  @media only screen and (max-width: 639px) {
    max-height: 150px;
  }
`;

const Select = ({
  options,
  value = null,
  placeholder = null,
  className = '',
  onChange,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [val, setVal] = useState(value);

  useEffect(() => setVal(value), [value]);

  const handleToggleDropdown = () => setShowDropdown(!showDropdown);
  const handleChange = (v) => () => {
    setShowDropdown(false);
    setVal(v);
    onChange(v);
  };

  return (
    <div className={`relative ${className}`}>
      <Content onClick={handleToggleDropdown}>
        {!val ? (
          <>{placeholder}</>
        ) : (
          <span className="text-primary text-base sm:text-11 sm:font-normal leading-5 truncate font-semibold">
            {val.label}
          </span>
        )}
        <DropButton
          key={showDropdown ? 'opened' : 'closed'}
          onClick={handleToggleDropdown}
        >
          {showDropdown ? (
            <svg
              width="11"
              height="5"
              viewBox="0 0 11 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.01402 0.00168896C5.18083 0.00136328 5.34248 0.0594583 5.47092 0.16589L9.75442 3.73547C9.90022 3.85665 9.9919 4.03079 10.0093 4.21956C10.0267 4.40834 9.96841 4.5963 9.84723 4.7421C9.72606 4.88789 9.55192 4.97957 9.36314 4.99698C9.17437 5.01438 8.98641 4.95608 8.84061 4.83491L5.01402 1.63656L1.18742 4.72068C1.1144 4.77998 1.03037 4.82427 0.940178 4.85099C0.849982 4.87771 0.755395 4.88635 0.661852 4.87639C0.568309 4.86644 0.477654 4.8381 0.395099 4.793C0.312544 4.7479 0.239716 4.68693 0.180801 4.61359C0.115421 4.54019 0.0659046 4.45407 0.0353546 4.36063C0.00480461 4.2672 -0.00612164 4.16847 0.00326157 4.07062C0.0126448 3.97276 0.0421333 3.8779 0.0898829 3.79198C0.137632 3.70605 0.202613 3.63092 0.280751 3.57127L4.56425 0.123055C4.69638 0.0334468 4.85474 -0.0092845 5.01402 0.00168896Z"
                fill="#181C34"
              />
            </svg>
          ) : (
            <svg
              width="11"
              height="5"
              viewBox="0 0 11 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.99831 4.99831C4.8315 4.99864 4.66985 4.94054 4.5414 4.83411L0.257904 1.26453C0.11211 1.14335 0.020426 0.969215 0.00302094 0.780437C-0.0143842 0.591658 0.0439156 0.403697 0.165095 0.257904C0.286274 0.11211 0.460406 0.020426 0.649185 0.00302095C0.837963 -0.0143841 1.02592 0.0439153 1.17172 0.165095L4.99831 3.36344L8.82491 0.279322C8.89793 0.22002 8.98196 0.175734 9.07215 0.149011C9.16235 0.122288 9.25693 0.113654 9.35048 0.123605C9.44402 0.133557 9.53468 0.161897 9.61723 0.206998C9.69979 0.252099 9.77261 0.313071 9.83153 0.386409C9.89691 0.459815 9.94642 0.545932 9.97697 0.639365C10.0075 0.732798 10.0185 0.831533 10.0091 0.929385C9.99968 1.02724 9.9702 1.1221 9.92245 1.20802C9.8747 1.29395 9.80972 1.36908 9.73158 1.42873L5.44808 4.87695C5.31594 4.96655 5.15759 5.00928 4.99831 4.99831Z"
                fill="#181C34"
              />
            </svg>
          )}
        </DropButton>
      </Content>
      {showDropdown && (
        <OutsideClickHandler onOutsideClick={() => setShowDropdown(false)}>
          <Dropdown>
            {options.map((option) => (
              <Option key={option.key} onClick={handleChange(option)}>
                {option.label}
              </Option>
            ))}
          </Dropdown>
        </OutsideClickHandler>
      )}
    </div>
  );
};

export default Select;
